/** Tela onde cada etapa do card de configuração do dashboard se resolve. */
const SETUP_ROUTES: Record<string, string> = {
	medium: "/mediums",
	linha_espiritual: "/spiritual-lines",
	guia: "/guides",
	tipo_atendimento: "/attendance-types",
	tipo_ritual: "/ritual-types",
	ritual: "/rituals",
	orixa: "/orixas",
	funcao: "/functions",
	etapa_jornada: "/journey-stages",
};

export const getSetupRoute = (key: string): string | null =>
	SETUP_ROUTES[key] ?? null;
